import { call, put, takeEvery } from 'redux-saga/effects';
import { publicDataService } from '../../services';
import {
  getTrafficStatusData,
  saveTrafficStatusData,
  changeLoading,
} from '../../features/publicDataSlice';
import { enqueueSnackbar } from '../../features/notificationSlice';

function* getPublicDataSaga(action) {
  try {
    yield put(changeLoading(true));
    const response = yield call(
      publicDataService.getPublicData,
      action.payload
    );

    yield put(saveTrafficStatusData(response.data));
    yield put(
      enqueueSnackbar({
        message: 'Get Data Success',
        options: {
          variant: 'success',
        },
      })
    );
  } catch (error) {
    console.log(error);
    yield put(changeLoading(false));
    yield put(
      enqueueSnackbar({
        message: error.message,
        options: {
          variant: 'error',
        },
      })
    );
  }
}

export default function* publicData() {
  yield takeEvery(getTrafficStatusData, getPublicDataSaga);
}
